module.exports = {"TXTCLI_LoadingXX":{"id":"TXTCLI_LoadingXX","defaultMessage":"Betöltés...","flags":["TRACK"],"track":"Loading..."}}